/* eslint-disable no-irregular-whitespace */
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
  title1: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
  introduction_text:
    '名古屋テレビ放送の人気番組「ハピキャン」と連動したデジタルキャンプ場を制作しました。このプロジェクトは、新たな技術の導入と、ユーザーとの双方向のコミュニケーションを実現するために実施しました。弊社はメタバース空間の構築を実施しました。',
  company: '名古屋テレビ放送株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '#222',
  background: '#F8F8F8',
  staff1: '名古屋テレビ放送株式会社　コンテンツビジネス局 プロデューサー 藤石崇文さん',
  staff2: '名古屋テレビネクスト株式会社　取締役 経営戦略部長 萩原悦子さん',
  image: '/images/img/cases/nagoyatv/top.webp',
  alt: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
  imgClass: 'fv_img_adjust2',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = 'メディアの進化に向けて、xRやメタバースでご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '名古屋テレビ放送株式会社は、「メ～テレ」の愛称で親しまれている1962年開局のテレビ朝日系列の地上波テレビ局です。（以下、メ～テレと表記）',
  },
  {
    text: `アイスリーデザインは、メ～テレの「Nex'BN」チームと共同で、「『キャンプ場の歩き方』をデジタルで再現するには？」をテーマとしたトライアルプロジェクト「いつでもどこでもハピキャン　～メタバースはじめてみました～」を開発しました。`,
  },
  {
    text: 'メタバースコンテンツ開発に込めた思い、そして制作プロジェクトとその進行について、メ～テレコンテンツビジネス局プロデューサーの藤石崇文さん、名古屋テレビネクスト株式会社取締役経営戦略部長の萩原悦子さん、そしてメ～テレ技術局設備戦略部の小林晋尚さんにお話を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'メディアの進化への適応',
        text: '放送を取り巻く環境が変化しており、一方的な情報提供から双方向コミュニケーションへの移行が求められている。',
      },
      {
        title: '新技術の導入',
        text: '2030年を見据えたメディアとしての進化には、xRやメタバースなど新しい技術の導入が必要。',
      },
      {
        title: 'ユーザー参加型コンテンツの開発',
        text: '視聴者との双方向コミュニケーションを促進するユーザー参加型コンテンツを開発することが課題。',
      },
    ],
    solutions: [
      {
        title: 'メタバースプラットフォームの選定と開発',
        text: '初心者にもわかりやすい説明とアプローチで、適切なメタバースプラットフォーム「Spatial」を選定し、デジタルキャンプ体験を実現。',
      },
      {
        title: '視聴者とのコミュニケーション強化',
        text: 'メタバース内でのキャンプを通じて、ユーザー間でのコミュニケーションを促進し、リアルなコミュニティ感を提供。',
      },
      {
        title: '実験的トライアルの実施',
        text: 'メタバースを用いた実験的なプロジェクトを通じて、新しい形のメディア体験を探求し、将来的なコンテンツ展開に向けた知見を蓄積。',
      },
    ],
  },
]


// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
